export const APPVERSION = process.env.REACT_APP_VERSION;
export const CURRENCY = "€"; //CURRENCY SYMBOL, CHANGE THIS PER CLIENT APP
